import {
  Group as GroupIcon,
  Storefront as StorefrontIcon,
  Settings as SettingsIcon,
  Inventory2 as ProductsIcon,
  Factory as FactoryIcon,
  People as PeopleIcon,
  LocalShipping as LocalShippingIcon,
  MenuBook as MenuBookIcon,
  Terminal as TerminalIcon,
} from '@mui/icons-material';

export const adminMenuSections = [
  {
    title: 'Tango',
    items: [
      { text: 'Clientes', icon: PeopleIcon, path: '/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'Pedidos al público',
    items: [
      { text: 'Pedido Público', icon: StorefrontIcon, path: '/orders/public', permission: 'orders.add_order' },
      { text: 'Clientes', icon: PeopleIcon, path: '/orders/public/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/orders/public/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'Pedidos mayoristas',
    items: [
      { text: 'Pedidos Mayoristas', icon: StorefrontIcon, path: '/orders/business', permission: 'orders.add_order' },
      { text: 'Clientes', icon: PeopleIcon, path: '/orders/business/clients', permission: 'clients.view_client' },
      { text: 'Productos', icon: ProductsIcon, path: '/orders/business/products', permission: 'products.view_product' },
    ],
  },
  {
    title: 'Producción',
    items: [
      { text: 'Producción', icon: FactoryIcon, path: '/production', permission: 'orders.view_order' },
    ],
  },
  {
    title: 'Reparto',
    items: [
      { text: 'Viajes', icon: LocalShippingIcon, path: '/trips', permission: 'delivery.view_trip' },
    ],
  },
  {
    title: 'General',
    items: [
      { text: 'Usuarios', icon: GroupIcon, path: '/users', permission: 'capriuser.view_user' },
      { text: 'Configuración', icon: SettingsIcon, path: '/settings', permission: 'settings.view_setting' },
    ],
  },
  {
    title: 'Documentación',
    items: [
      // Páginas estáticas servidas desde public/; se abren fuera del router
      { text: 'Manual de Uso', icon: MenuBookIcon, path: '/manual.html', external: true, permission: null },
      { text: 'Doc. Técnica', icon: TerminalIcon, path: '/docs.html', external: true, permission: 'settings.view_setting' },
    ],
  },
];

export const wholesaleMenuSections = [
  {
    title: 'Pedidos mayoristas',
    items: [
      { text: 'Pedidos Mayoristas', icon: StorefrontIcon, path: '/orders/business', permission: null },
    ],
  },
];
